import { EnhancedFieldConfig } from '../../types/form/schema.types';
import { validateRequired } from '../Utils';
import { createShowWhenEqualsDependency } from './dependencies';

export interface RejectionTextareaOptions {
  name: string;
  label: string;
  disabled: boolean;
  decisionField: string;
  validationMessage: string;
  rejectionValue?: unknown;
  isInvalid?: (value: unknown) => boolean;
}

export const createRejectionTextarea = ({
  name,
  label,
  disabled,
  decisionField,
  validationMessage,
  rejectionValue = 'no',
  isInvalid,
}: RejectionTextareaOptions): EnhancedFieldConfig => ({
  type: 'textArea',
  name,
  label,
  required: true,
  validate: (value: unknown): string | undefined =>
    (isInvalid?.(value) ?? Boolean(validateRequired(value, label)))
      ? validationMessage
      : undefined,
  disabled,
  dependencies: [
    createShowWhenEqualsDependency(decisionField, rejectionValue),
  ],
});
